import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  NavigationContent,
  Container,
  MobileNavigationContainer,
  ProgressAndHeadingContainer
} from './Navigation.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { usePatient } from 'hooks/usePatient/usePatient';
import { networkClinicCopy } from 'screens/Book/networkClinicBookingCopy';
import { pageUrl } from 'utilities/pageUrl';
import { useBreakpoints } from 'utilities/useBreakpoints';

import { getBookingStepTitle } from './Navigation.utils';
import { ProgressTracker } from '../ProgressTracker/ProgressTracker';

interface NavigationProps {
  step?: string | null;
  //TODO: try to remove
  onBack?: () => void;
  forwardFunction?: () => void;
  forwardDisabled?: boolean;
  forwardText?: string;
  isForwardClicked?: boolean;
  isPartnerClinicSearch?: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({
  step,
  onBack,
  forwardFunction,
  forwardText,
  forwardDisabled,
  isPartnerClinicSearch
}) => {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoints();
  const { patient } = usePatient();
  const stepTitle = getBookingStepTitle(step);

  if (step === 'success') return;

  const showForwardNavigation = Boolean(forwardFunction);
  const proceedText = getProceedText(Boolean(isPartnerClinicSearch));

  const onClick = () => {
    onBack?.();

    if (window.history.length <= 1) {
      navigate(pageUrl.dashboard());
    } else {
      navigate(-1);
    }
  };

  return (
    <Container $isPatientLoggedIn={Boolean(patient)}>
      {isDesktop ? (
        <NavigationContent>
          <Button
            label="Back"
            size={isDesktop ? 'md' : 'lg'}
            category="secondary"
            onClick={onClick}
          />
          <ProgressAndHeadingContainer>
            <ProgressTracker step={step} />
            <Heading tag="h3" styledAs="h3" noMargin>
              {stepTitle}
            </Heading>
          </ProgressAndHeadingContainer>
          {showForwardNavigation ? (
            <Button
              label={forwardText || 'Continue'}
              size={isDesktop ? 'md' : 'lg'}
              category="primary"
              onClick={forwardFunction}
              isDisabled={forwardDisabled}
            />
          ) : (
            <Text size="lg" fontStyle="regular">
              {proceedText}
            </Text>
          )}
        </NavigationContent>
      ) : (
        <MobileNavigationContainer>
          {forwardFunction && (
            <Button
              label={forwardText || 'Continue'}
              size={'lg'}
              fullWidth
              category="primary"
              onClick={forwardFunction}
              isDisabled={forwardDisabled}
            />
          )}
          <Button label="Back" size={'lg'} fullWidth category="secondary" onClick={onClick} />
        </MobileNavigationContainer>
      )}
    </Container>
  );
};

const getProceedText = (isPartnerClinicSearch: boolean) => {
  if (!isPartnerClinicSearch) return 'Select an Option To Proceed';

  return networkClinicCopy.zipProceedLabel;
};
